module.exports = __webpack_public_path__ + "img/1641676205326.c543c17c.jpeg";